import { axiosIns } from "../utils";

export const fetchSubscribers = async () => {
  const res = await axiosIns.get("/administration/subscribers");
  return res && res.data ? res.data : res;
};

export const fetchAdminSubscriptions = async () => {
  const res = await axiosIns.get("/administration/subscriptions");
  return res && res.data ? res.data : res;
};

export const fetchSubscriptions = async () => {
  const res = await axiosIns.get("/subscriptions");
  return res && res.data ? res.data : res;
};

export const fetchSubscriptionTypes = async () => {
  const res = await axiosIns.get("/subscription-types");
  return res && res.data ? res.data : res;
};

export const fetchPricing = async () => {
  const res = await axiosIns.get("/pricing");
  return res && res.data ? res.data : res;
};

export const fetchFactures = async () => {
  const res = await axiosIns.get("/factures/");
  return res && res.data ? res.data : res;
};

export const fetchAdminUsersList = async () => {
  const res = await axiosIns.get("/administration/users/list");
  return res && res.data ? res.data : res;
};

export const createAdminUser = async (payload) => {
  const res = await axiosIns.post("/administration/users/", payload);
  return res && res.data ? res.data : res;
};

export const fetchDemoUsersList = async () => {
  const res = await axiosIns.get("/administration/users/demo/list/");
  return res && res.data ? res.data : res;
};

export const createDemoUser = async (payload) => {
  const res = await axiosIns.post("/administration/users/demo/", payload);
  return res && res.data ? res.data : res;
};
